import React from 'react';
import c from 'classnames';
import s from './ButtonBorder.scss';
const ButtonBorder = ({ children, className })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: c(s['root'], className)
    }, children);
};
ButtonBorder.displayName = 'ButtonBorder';
export default ButtonBorder;

//# sourceMappingURL=ButtonBorder.js.map